import { render } from "./JoinSuccess.vue?vue&type=template&id=0aabf0c5&scoped=true"
import script from "./JoinSuccess.vue?vue&type=script&lang=js"
export * from "./JoinSuccess.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0aabf0c5"

export default script